import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { READ_ONLY_METRICS_CARD_SUBTITLE } from './constants';

const useStyles = makeStyles((theme) => ({
	root: {
		height: 'auto',
	},
}));

export const ReadOnlyMetricsCard = () => {
	const classes = useStyles();

	return (
		<Card className={classes.root}>
			<CardContent>
				<Grid container justifyContent='space-between'>
					<Grid item style={{ width: '100%' }}>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='space-around'
						>
							<Typography gutterBottom variant='subtitle1'>
								{READ_ONLY_METRICS_CARD_SUBTITLE}
							</Typography>
						</Box>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};
